<div *ipEmailBuilderSettings [ipEmailBuilderHistoryHost]="this | toHistoryOptions">
  <h2 tailH2 i18n="@@spacer_block_size">Size</h2>
  <div tailPanel>
    <tail-width-height [(value)]="options.height!"></tail-width-height>
  </div>
</div>
